import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AccountService } from '../../shared/account.service';
import { Account } from '../../shared/account.model';
import { trigger, style, transition, animate, keyframes } from '@angular/animations';

@Component({
  selector: 'app-account-dashboard-list',
  templateUrl: './account-dashboard-list.component.html',
  styleUrls: ['./account-dashboard-list.component.scss'],
  animations: [
    trigger('openClose', [
      transition('* => *', [
        animate('0.25s', keyframes([
          style({ opacity: 0 }),
          style({ opacity: 1 }),
        ]),
        ),
      ])
    ])
  ]
})
export class AccountListComponent implements OnChanges, OnInit {

  @Input() month = '';
  accounts?: Account[];
  accountsPerUser?: Account[][];

  displayedLabels?: string;
  isOpen = true;

  groupByAttribute = 'paidById';
  filterAttribute = 'categoryName';
  displayedColumns = ['paidOn', 'supplierName', 'amount'];

  constructor(private _accountService: AccountService) { }

  async ngOnChanges(changes: SimpleChanges) {
    if (changes.month) {
      this.accounts = await this._accountService.retrieveAllAccounts(this.month);
    }
  }

  async ngOnInit() {
    if (!this.accounts) {
      this.accounts = await this._accountService.retrieveAllAccounts(this.month);
    }
  }

  getTotalAmount(accounts: Account[]) {
    return accounts.map(a => a.amount)
      .filter(a => a !== null)
      .reduce((acc: number, value) => acc + (value || 0), 0);
  }

  onLegendClicked(displayedLabels: string[]) {
    this.isOpen = !this.isOpen;
    this.displayedLabels = displayedLabels.join(';');
  }
}
